import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonList, IonItem, IonLabel, IonInput } from '@ionic/angular/standalone';
import { PageActionComponent, SuperButtonComponent, SuperStepItemComponent } from '@qid/super';
import { TemplateFieldSetterComponent } from "../../components/template-field-setter/template-field-setter.component";
import { TemplateIdSetterComponent } from "../../components/template-id-setter/template-id-setter.component";
import { CreateCollectionTemplateDto } from '../../dto/create-collection-template.dto';
import { CollectionTemplate } from '../../models/CollectionTemplate';
import { CollectionTemplateService } from '../../services/collection-template.service';

@Component({
  selector: 'app-create-collector-template',
  templateUrl: './create-collector-template.page.html',
  styleUrls: ['./create-collector-template.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SuperButtonComponent,
    SuperStepItemComponent,
    PageActionComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput
  ]
})
export class CreateCollectorTemplatePage implements OnInit {

  public collectionTemplate: CreateCollectionTemplateDto = new CreateCollectionTemplateDto();
  public title: string = 'Create Template';

  @Input() template: CollectionTemplate = null;

  constructor(
    private collectionTemplateService: CollectionTemplateService,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    this.fetchRouterData();
  }

  ionViewDidEnter() {
  }

  async fetchRouterData() {
    if (this.template && this.template._id) {
      this.title = 'Edit Template';
      this.applyTemplate(this.template);
      return;
    }

    return;
  }

  public createTemplate = async () => {

    if (!this.collectionTemplate.purpose || this.collectionTemplate.purpose.length < 1) {
      throw "Set Template Purpose"
    }

    if (this.collectionTemplate.acceptedIds.length < 1) {
      throw "Please choose IDs to collect"
    }

    this.template = await this.collectionTemplateService.create(
      this.collectionTemplate
    );
    this.dismiss(this.template);

  };

  public updateTemplate = async () => {
    try {
      const res = await this.collectionTemplateService.update(
        this.collectionTemplate
      );
      if (res && res.data) {
        this.template = res.data
        this.dismiss(this.template);
      }
    } catch (e) {
      console.error(e);
    }
  };

  applyTemplate(template: CollectionTemplate) {
    this.collectionTemplate._id = template._id;
    this.collectionTemplate.purpose = template.purpose;
    this.collectionTemplate.isPublic = template.isPublic;
    this.collectionTemplate.isAtLeastOneAmongOptional =
      template.isAtLeastOneAmongOptional;
    this.collectionTemplate.otherInfo = template.otherInfo;
    this.collectionTemplate.acceptedIds = template.acceptedIds;
  }

  dismiss(template = null) {
    this.modalController.dismiss({ template: template });
  }

  public async openIdSetter() {
    const modal = await this.modalController.create({
      component: TemplateIdSetterComponent,
      componentProps: {
        defaultIds: this.collectionTemplate.acceptedIds,
      },
    });
    await modal.present();
    const modalRes = await modal.onDidDismiss();
    if (modalRes && modalRes.data?.acceptedIds) {
      this.collectionTemplate.acceptedIds = modalRes.data.acceptedIds;
    }
  }

  public async openFieldSetter() {
    const modal = await this.modalController.create({
      component: TemplateFieldSetterComponent,
      componentProps: {
        otherInfo: this.collectionTemplate.otherInfo,
      },
    });
    await modal.present();
    const modalRes = await modal.onDidDismiss();
    if (modalRes && modalRes.data?.otherInfo) {
      this.collectionTemplate.otherInfo = modalRes.data.otherInfo;
    }
  }
}
